<template>
  <div>
    <div v-if="transaction && transaction.api_result">
      <div class="border">
        <h4>Подписать договор # {{ transaction.exchange_additional_id }}</h4>
        <!-- <pre>{{ transaction.api_result }}</pre> -->
        <div>
          <label>ФИО (договор)</label>
          <h5 class="text-uppercase m-0">
            {{ transaction.api_result.paymart_client.fio }}
          </h5>
          <label>ФИО (представился)</label>
          <h5 class="text-uppercase m-0">
            {{ order.client.full_name }}
          </h5>
          <label>Номер телефона</label>
          <h5 class="text-uppercase m-0">
            {{ order.client.phone }}
          </h5>
        </div>

        <h4>Товар-(ы)</h4>
        <table class="table border w-100">
          <thead>
            <tr>
              <td><b>Товар</b></td>
              <td align="right"><b>Цена</b></td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(cart, index) in transaction.api_result.cart"
              :key="index"
            >
              <td>
                {{ cart.name }} ✕ {{ cart.amount }}
                <span v-if="cart.imei" class="text-info">
                  {{ cart.imei }}
                </span>
              </td>
              <td align="right">{{ cart.price }} UZS</td>
            </tr>
          </tbody>
        </table>
        <div>
          <h5 class="m-0 p-0 text-info text-bold">
            Пероид рассрочки:
            {{ transaction.month }} {{ "mo" | setText }}
          </h5>
          <h5 class="mb-3 mt-0 p-0 text-info text-bold">
            Оплата в месяц:
            {{
              transaction.api_result.paymart_client.price_month
                | spaceBetweenNumber
            }}
            UZS / {{ "mo" | setText }}
          </h5>

          <!-- <pre>{{ transaction }}}</pre> -->
        </div>
        <hr/>

        <div class="mb-4">
          <h4 class="mb-1">1. Скачайте договор и распечатайте</h4>
          <a
            class="btn btn-info mw"
            :href="transaction.api_result.client_act_pdf"
            target="_blank"
            >Скачать договор</a
          >
        </div>

        <div class="mb-4">
          <h4 class="mb-1">2. Верифицируйте клиента и подпишите договор</h4>
          <a class="btn btn-info mw" :href="transaction.api_result.webview_path"
            >Подписать договор</a
          >
        </div>

        <div>
          <h4 class="mb-1">3. Убедитесь, что клиент подписал договор и подтвердите</h4>

          <button class="btn btn-info mw mb-3" @click="send" target="_blank">
            Подтвердить договор
          </button>
        </div>
      </div>

      <div class="border">
        <h4>Отмена заказа</h4>

        <button class="btn btn-danger mw mb-3" @click="cancel" target="_blank">
          Отменить договор
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
export default {
  computed: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    transaction: {
      default: function () {},
    },
    value: {
      default: null,
    },
  },
  async created() {},
  methods: {
    async send() {
      this.$loading(true);
      let data = {
        contract_id: this.transaction.exchange_additional_id, //изменили в документации. было exchange_id
      };
      this.$http
        .post(
          `${this.partner["endpoint_url"]}v3/uzum/contract-confirm?company_id=${this.partner.api_public_key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(async (response) => {
          if (
            response.data.status == "success" ||
            response.data.status == "1"
          ) {
            await this.createTransaction({
              client_confirmed: 1,
              system_confirmed: 1,
              step: "order-done",
              pre_api_result: JSON.stringify(response.data.data),
            });
            this.$emit("setStep", "order-done");
          } else if (response.data.message) {
            this.$loading(false);
            this.$notify({
              title: "UZUM NASIYA",
              message: response.data.message,
              type: "danger",
            });
          } else {
            this.$loading(false);
            this.$notify({
              title: "UZUM NASIYA",
              message: "Заказ не подтвержден",
              type: "danger",
            });
          }
        })
        .catch((error) => {
          this.$loading(false);
          errorNotify(error, this.$notify);
          try {
            if (error.response.data.error && error.response.data.error.length) {
              for (let i = 0; i < error.response.data.error.length; i++)
                this.$notify({
                  title: "UZUM NASIYA",
                  message: error.response.data.error[i]["text"],
                  type: "danger",
                });
            }
          } catch (error) {}
        })
        .finally(async () => {
          //testdenis
          // await this.createTransaction({
          //   client_confirmed: 1,
          //   system_confirmed: 1,
          //   step: "order-done",
          // });
          // this.$emit("setStep", "order-done");
        });
    },
    async cancel() {
      this.$loading(true);
      let data = {
        contract_id: this.transaction.exchange_id,
        buyer_phone: this.order.client.phone,
      };
      this.$http
        .post(
          `${this.partner["endpoint_url"]}v1/buyers/credit/cancel?company_id=${this.partner.api_public_key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(async (response) => {
          const rData = response.data;
          if (
            (rData.result && rData.result.status == 1) ||
            (rData.status && rData.status == 1)
          ) {
            await this.createTransaction({
              client_confirmed: 0,
              system_confirmed: 0,
              status: "-1",
            });
          } else {
            this.$loading(false);
            this.$notify({
              title: "UZUM NASIYA",
              message: response.data.error,
              type: "danger",
            });
          }
        })
        .catch((error) => {
          this.$loading(false);
          errorNotify(error, this.$notify);
        })
        .finally(() => {});
    },
  },
  data() {
    return {};
  },
};
</script>



